export const ONE_SGD = 100000;
export const ALLOWED_MIN_SGD = 2;
export const ALLOWED_MIN_PRICE = ONE_SGD * ALLOWED_MIN_SGD;
export const DEFAULT_SQUAD_PRICE = 1000000;
export const DEFAULT_MIN_PRICE = 500000;
export const DEFAULT_MAX_PRICE = 1500000;